import { useMemo } from 'react';
import { deriveBalances } from './derive';
import { useBalances } from './useBalances';
import { useOutcomeMetaForNames } from '../catalog/useOutcomeMeta';
import { useMids } from './useMarketData';

/** Link to an outcome market page, keeping ?ghost= while ghosting. */
export function marketHref(outcome: number, side: number, ghost: string | null): string {
  const p = new URLSearchParams({ side: String(side) });
  if (ghost) p.set('ghost', ghost.toLowerCase());
  return `/market/${outcome}?${p.toString()}`;
}

/** Balances + outcomeMeta + mids, derived for the panels (one shared spotState subscription per address). */
export function useDerivedBalances(address: string | null) {
  const bal = useBalances(address);
  const meta = useOutcomeMetaForNames(address !== null);
  const mids = useMids(address !== null);
  const derived = useMemo(() => deriveBalances(bal.data, meta, mids), [bal.data, meta, mids]);
  return { ...bal, derived };
}
